let Drop = require("./Drop");
let IconButton = require("./IconButton");
let Format = require("../lib/Format");
let Keyboard = require("../lib/Keyboard");

function Page(props) {
  let { year, month, selected, onSelect } = props;

  let onClick = function (date, evt) {
    onSelect(date);
  };

  let onKeyUp = function (date, evt) {
    if (Keyboard.isEnter(evt)) {
      onSelect(date);
    }
  };

  let date = new Date();
  let today = { year: date.getFullYear(), month: date.getMonth(), day: date.getDate() };
  let daysInMonth = new Date(year, month + 1, 0).getDate();
  let day = 1 - new Date(year, month, 1).getDay();

  let isDayInMonth = function (i) {
    return i > 0 && i <= daysInMonth ? i : null;
  };

  let equals = function (a, b) {
    return a && b && a.year === b.year && a.month === b.month && a.day === b.day;
  };

  let heads = "SMTWTFS".split("").map(function (label, i) {
    return <th key={i}>{label}</th>;
  });

  let rows = [];

  let cells = (function () {
    return heads.map(function () {
      let enabled = isDayInMonth(day); 
      let date = { year, month, day };

      return (
        <td
          key={day}
          tabIndex={enabled ? 0 : null}
          aria-disabled={!enabled}
          data-today={equals(date, today)}
          data-selected={equals(date, selected)}
          onClick={enabled ? onClick.bind(this, date) : null}
          onKeyUp={enabled ? onKeyUp.bind(this, date) : null}>
            {isDayInMonth(day++)}
        </td>
      );
    }, this);
  }).bind(this);

  for (let i = 0; i < 6; i++) {
    rows.push(<tr key={i}>{cells()}</tr>);
  }

  return (
    <table>
      <thead>
        <tr>
          {heads}
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </table>
  );
}

class Calendar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      now: new Date()
    };
  }

  flip(offset) {
    this.setState({
      page: this.state.page + offset
    });
  }

  render() {
    let { pages, selected, onSelect } = this.props;
    let { now, page } = this.state;

    let y = now.getFullYear();
    let m = now.getMonth() + page;
    let months = [];

    for (let i = 1 - pages; i <= 0; i++) {
      months.push(
        <div className="mc-date-picker-page" key={i}>
          <h4>{Format.date(new Date(y, m + i, 1), null, "cal")}</h4>
          <Page year={y} month={m + i} selected={selected} onSelect={onSelect.bind(this)}/>
        </div>
      );
    }

    return (
      <div className="mc-date-picker">
        <div className="mc-date-picker-nav">
          <IconButton icon="back" scale={0.9} onPress={() => this.flip(-1)}/>
          <IconButton icon="forward" scale={0.9} onPress={() => this.flip(1)}/>
        </div>
        <div>
          {months}
        </div>
      </div>
    );
  }
}

Calendar.defaultProps = {
  pages: 1,
  selected: null,
  onSelect: function (date) {
  }
};

class DatePicker extends React.Component {
  onSelect(date) {
    this.props.onSelect(date);

    this.refs.drop.close();
  }

  render() {
    let { pages, align, selected } = this.props;

    return (
      <Drop ref="drop" selector="button, td[aria-disabled=false]" align={align}>
        <div className="mc-drop-handle">
          {Format.date(new Date(selected.year, selected.month, selected.day), null, "short")}
        </div>
        <div className="mc-drop-content mc-drop-calendar">
          <Calendar pages={pages} align={align} selected={selected} onSelect={this.onSelect.bind(this)}/>
        </div>
      </Drop>
    );
  }
}

let today = new Date();

DatePicker.defaultProps = {
  pages: 1,
  selected: {
    year: today.getFullYear(),
    month: today.getMonth(),
    day: today.getDate()
  },
  onSelect: function () {
  },
  align: "left"

};

module.exports = DatePicker;
